import { createAction } from '@reduxjs/toolkit';

export const clearUsersStatuses = createAction('CLEAR_USERS_STATUSES');
export const clearUsersFetchStatus = createAction('CLEAR_USERS_FETCH_STATUS');
